import request from "@/utils/request";

export function getUserPage(data,pageNum,pageSize) {
    return request({
        url: `/user/findPage4Investor`,
        method: 'post',
        params:{pageNum,pageSize},
        data
    })
}
